import { render, staticRenderFns } from "./orgFlexipass.vue?vue&type=template&id=67dbe968&scoped=true&"
import script from "./orgFlexipass.vue?vue&type=script&lang=js&"
export * from "./orgFlexipass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dbe968",
  null
  
)

export default component.exports